// extracted by mini-css-extract-plugin
export default {"modalFooter":"fishing_report_modal__modalFooter--+sNn","modal":"fishing_report_modal__modal--50iy"};